import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Ринок» (/market/ueex) — РЕДИЗАЙН.
 *
 * Секція та глибина вікна винесені в топбар за §6 дизайн-контракту: раніше
 * секції жили у власній правій колонці-сайдбарі шириною 256px, якої немає
 * більше ніде в кабінеті, а вибір періоду — у заголовку сторінки.
 *
 * Прийом той самий, що useSkoUi / useTradingUi / useAssetsUi.
 */
const EV = 'helios:ueex-ui-change';

export type UeexSection =
  | 'electric_power'
  | 'bilateral_contracts'
  | 'solar_go'
  | 'renewable_go'
  | 'auctions';

export const UEEX_DAYS = [7, 14, 30, 60, 90, 180, 365] as const;

const state = { section: 'electric_power' as UeexSection, days: 30 as number };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useUeexUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setSection = useCallback((s: UeexSection) => {
    if (state.section !== s) { state.section = s; emit(); }
  }, []);
  const setDays = useCallback((d: number) => {
    if (state.days !== d) { state.days = d; emit(); }
  }, []);

  return { section: state.section, days: state.days, setSection, setDays };
}
